module.exports = __webpack_public_path__ + "static/media/BudgetSmartBtn.8ad8d0c9.svg";